import { Box, Container, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useDocumentMetaData } from "../components/useDocumentMetaData";

export default function Career() {
  useDocumentMetaData({
    title: "Careers at MidWest Group - Join Our Team",
    description:
      "Explore career opportunities at MidWest Group. Join our team of dedicated professionals and thrive in a dynamic construction and interior services environment.",
    keywords:
      "MidWest Group careers, job openings, construction jobs Calgary, Alberta jobs, building services careers, join our team",
    canonical: "https://www.midwest-group.com/careers/",
    author: "MidWest Group",
    ogTitle: "Careers at MidWest Group",
    ogDescription:
      "MidWest Group is hiring! Join our fast-growing company and work on innovative construction and interior projects in Calgary, Alberta.",
    ogImage: "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png", // optional relevant image, like a team photo
    ogUrl: "https://www.midwest-group.com/careers/",
    twitterTitle: "Careers at MidWest Group",
    twitterDescription:
      "Looking for exciting career opportunities in Calgary? Join MidWest Group and grow in a dynamic construction and interior services environment.",
    twitterImage: "https://www.midwest-group.com/static/media/midwestlogo.44c18281703536901c7e.png",
  });

  return (
    <>
      <Container
        sx={{
          minHeight: "55vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flex: "1", paddingTop: 5 }}>
          <Box sx={{ textAlign: "center" }}>
            <Typography
              variant="h2"
              component="h2"
              style={{ fontWeight: "600" }}
              gutterBottom
              className="Main-content"
            >
              Careers
            </Typography>
          </Box>
          <p style={{ fontSize: "18px" }} className="aboutparagraph">
            Join our team!
          </p>
          <p style={{ textAlign: "center" }}>
            As a fast-growing company, we are searching for candidates who align
            with our core values. We offer a dynamic, fast-paced work
            environment where driven, self-motivated individuals can thrive.
            Joining our team means committing to providing the highest level of
            professional building services and innovative construction
            technology solutions.
          </p>
          <p style={{ textAlign: "center" }}>
            To learn more please visit:{" "}
            <Link
              style={{ textDecoration: "none", color: "#5f8c27" }}
              to="https://www.thermalsystems.ca/join-our-team/"
              target="_Blank"
            >
              https://www.thermalsystems.ca/join-our-team/
            </Link>
          </p>
        </Box>
      </Container>
    </>
  );
}
